<template>
  <div
    class="msg-media"
  >
    <img v-if="data.mediaType === 1" :src="data.mediaUrl" />
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
  data() {
    return {
      selectedText: '',
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.msg-media {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  box-sizing: border-box;
  padding: 7px 12px;
  background: #f3f5fa;
  border-radius: 0px 6px 6px 6px;
  color: #262d3d;
  max-width: 80%;

  img {
    max-width: 100%;
  }
}
</style>
